<template>
  <div class="cooperation_wrap ">
    <div class="pc_container">
      <div class="cooperation_tit">{{services.info.title}}</div>
      <div class="cooperation_desc">{{services.info.sub_title}}</div>
      <div class="cooperation_bottom">
        <div class="details_show">
          <div class="show_item" v-for="(item,index) in services.list" :key="index">
            <div class="show_top">{{item.value}}</div>
            <div class="show_bottom">{{item.label}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    services:{
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
     
    }
  },
  methods: {
    
  },
}
</script>

<style lang="scss" scoped>
.cooperation_wrap {
  text-align: center;
  margin-bottom: 30px;
  margin-top: 30px;
  >div{
    // background: url('../../assets/images/home/cooperation_bg.png') 0 0 repeat-y;
    // background-size: 100% 100%;
    background-color: white;
    box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
  }
  .cooperation_tit {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-size: 35px;
    color: #000;
    padding-top: 47px;
  }
  .cooperation_desc {
    font-family: Microsoft YaHei, Microsoft YaHei;
    color: #545454;
    font-size: 16px;
    margin-top: 8px;
  }
}
.cooperation_bottom {
  width: 100%;
  height: 174px;
  .details_show {
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    .show_item {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .show_top {
        color: #0F95FD;
        font-size: 48px;
      }

      .show_bottom {
        color: #2E2E2E;
        font-size: 14px;
        margin-top: 10px;
      }
    }
  }
}
</style>